<template>
    <div
        v-if="loginForm"
        class="d-flex justify-space-around align-center loginWrapper"
    >
        <!-- Card Wrapper -->
        <!--============================ -->
        <v-card
            class="elevation-24 login-card-wrapper"
            dark
            shaped
        >
            <!-- Content Wrapper -->
            <!-- =========================== -->
            <div
                class="content-wrapper d-flex justify-space-around align-center flex-column "
            >
                <div class="logoBg">
                    <div class="whiteCross">
                        <img
                            src="./../../assets/hmi-cross.png"
                            alt="HMI Logo"
                            fetchpriority="high"
                            decoding="async"
                            width="100vw"
                            height="100vh"
                        >
                    </div>
                </div>
                <!-- Inputs -->
                <div
                    class="loginInputs d-flex justify-space-around align-center flex-column"
                >
                    <div class="header">
                        <transition name="fade" mode="out-in">
                            <div v-if="selectedRole === 0" key="member-portal-title">
                                <h2 class="font-weight-black">
                                    HMI Member's Portal
                                </h2>
                            </div>
                            <div v-if="selectedRole === 1" key="provider-portal-title">
                                <h2 class="font-weight-black">
                                    HMI Provider's Portal
                                </h2>
                            </div>
                        </transition>
                    </div>
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                        class="loginForm"
                    >
                        <!-- TEXT FIELDS -->
                        <div class="textFields">
                            <v-btn-toggle
                                v-model="selectedRole"
                                small
                                class="userRole d-flex flex-row"
                                @change="changeRuleBaseOnSelectedRole"
                            >
                                <v-btn
                                    :color="selectedRole === 0 ? '#00C853' : ''"
                                    class="flex-grow-1"
                                    style="height: 42px"
                                    @mousedown="$refs.form.reset()"
                                >
                                    <v-icon>{{ mdiAccount }}</v-icon> MEMBER
                                </v-btn>
                                <v-btn
                                    :color="selectedRole === 1 ? '#00C853' : ''"
                                    class="flex-grow-1"
                                    style="height: 42px"
                                    @mousedown="$refs.form.reset()"
                                >
                                    <v-icon>{{ mdiHospitalBuilding }}</v-icon> PROVIDER
                                </v-btn>
                            </v-btn-toggle>
                            <transition name="fade" mode="out-in">
                                <v-text-field
                                    v-if="selectedRole === 0"
                                    ref="membN"
                                    key="login_membcode"
                                    v-model.trim="membcode"
                                    v-mask="'######'"
                                    dense
                                    label="Member Code"
                                    color="green"
                                    :rules="rules.membCodeRule"
                                    outlined
                                    :prepend-inner-icon="mdiAccount"
                                />
                                <v-text-field
                                    v-if="selectedRole === 1"
                                    ref="userN"
                                    key="login_provusername"
                                    v-model.trim="hospusername"
                                    dense
                                    label="Username"
                                    :rules="rules.userEmailRules"
                                    color="green"
                                    outlined
                                    :prepend-inner-icon="mdiHospitalBuilding"
                                    autocomplete="nope"
                                />
                            </transition>
                            <v-text-field
                                v-model="password"
                                dense
                                label="Password"
                                color="green"
                                :rules="rules.passRules"
                                password
                                :prepend-inner-icon="mdiLock"
                                outlined
                                autocomplete="nope"
                                :append-icon="showPassword ? mdiEye : mdiEyeOff"
                                :type="showPassword ? 'text' : 'password'"
                                @keypress.enter="validate(), (loginStatus = !loginStatus)"
                                @click:append="showPassword = !showPassword"
                            />
                            <a style="color: #FFFFFF;" href="/forgotPass">Forgot password?</a>
                        </div>
                    </v-form>
                    <!-- SIGN-IN BUTTON -->
                    <v-btn
                        color="green accent-4"
                        width="70%"
                        height="55px"
                        class="white--text"
                        rounded
                        :loading="loading"
                        @click="validate(), (loginStatus = !loginStatus)"
                    >
                        Sign in
                    </v-btn>
                    <transition name="fade" mode="out-in">
                        <div
                            v-if="selectedRole === 0"
                            key="signupmember"
                            class="my-3 text-center"
                        >
                            Member not yet registered?
                            <span @click="toSignUp(loginForm)">Sign up here</span>
                        </div>
                        <div
                            v-if="selectedRole === 1"
                            key="signupprovider"
                            class="my-3 text-center"
                        >
                            Provider not yet registered? Kindly contact HMI.
                        </div>
                    </transition>

                    <div class="my-3 text-center" style="margin: 10%;">
                        <h6>
                            Health Maintenance, Inc. is fully compliant with the Data Privacy Act of 2012. For more information, kindly read the <a
                                href="https://www.hmi.com.ph/data-privacy"
                                target="_blank"
                                rel="noopener noreferrer"
                                style="color:green"
                            >Data Privacy Statement</a>.
                        </h6>
                    </div>
                </div>
                <!-- END INPUTS  -->
            </div>

            <!-- Dialog box if account is INACTIVE or other STATUS -->
            <dlgAccountLoginStatus
                v-if="getLoginErr"
                :login-status="loginStatus"
                :get-user-login-status="getUserLoginStatus"
                @loginStatusDiagShow="loginStatusDiagShow"
            />
            <!-- wrapper -->
        </v-card>
    </div>
</template>

<script>
import dlgAccountLoginStatus from './DialogBoxes/dlgAccountLoginStatus.vue'
import { mapActions, mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'
import { mdiAccount, mdiEye, mdiEyeOff, mdiHospitalBuilding, mdiLock } from '@mdi/js'
export default {
    components: { dlgAccountLoginStatus },
    directives: { mask },
    props: ['loginForm'],
    data: () => ({
        mdiAccount, mdiEye, mdiEyeOff, mdiHospitalBuilding, mdiLock,
        loading: false,
        errLogin: {
            status: false,
            message: null
        },
        screen_width: document.documentElement.clientWidth + 9,
        selectedRole: 0,
        hospusername: '',
        membcode: '',
        password: '',
        showPassword: false,
        rules: {
            passRules: [(v) => !!v || 'Password is required'],
            membCodeRule: [(v) => !!v || 'Member Code is required'],
            userEmailRules: [()=>true]
        },
        rulesDefault: {
            noRule: [()=>true],
            membCodeRule: [(v) => !!v || 'Member Code is required'],
            userEmailRules: [(v) => !!v || 'Username is required']
        },
        valid: true,
        loginStatus: false
    }),
    computed: {
        ...mapGetters([
            'getLoginErr',
            'getModifierForUserLogin',
            'getUserLoginStatus'
        ])
    },
    watch: {
        getLoginErr(newVal) {
            if (newVal && newVal !== '') {
                this.loading = false
                this.errLogin.status = true
                this.errLogin.message = newVal
                setTimeout(()=>{
                    this.errLogin.status = false
                }, 5000)
            }
        },
        selectedRole(newVal, oldVal) {
            if (newVal === undefined) this.selectedRole = oldVal
            this.$nextTick(()=>{
                setTimeout(()=>{
                    if (this.screen_width>768) {
                        if (this.$refs&&this.$refs.membN) this.$refs.membN.focus()
                        else if (this.$refs&&this.$refs.userN) this.$refs.userN.focus()
                    }
                }, 300)
            })
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
        this.$nextTick(()=>{
            setTimeout(()=>{
                if (this.$refs&&this.$refs.membN&&this.screen_width>768) this.$refs.membN.focus()
            }, 300)
        })
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['toSignupLogin', 'loginValidation', 'loginValidationProvider']),
        loginStatusDiagShow(loginStatus) {
            this.loginStatus = loginStatus
        },
        output() {
            this.printData()
        },
        // Form Validation if no input
        validate() {
            const selectedRole = this.changeRuleBaseOnSelectedRole()
            if (!this.$refs.form.validate()) {
                this.$refs.form.validate()
            } else {
                this.loading = true
                if (selectedRole === 'provider') {
                    this.loginValidationProvider({ USERNAME: this.hospusername, PASSWORD: this.password })
                } else {
                    this.loginValidation({ MEMBN: this.membcode, PASS: this.password })
                }
            }
        },
        changeRuleBaseOnSelectedRole() {
            const { noRules, userEmailRules, membCodeRule } = this.rulesDefault
            if (this.selectedRole === 1) {
                this.rules.membCodeRule   = noRules
                this.rules.userEmailRules = userEmailRules
                return 'provider'
            } else {
                this.rules.membCodeRule   = membCodeRule
                this.rules.userEmailRules = noRules
                return  'member'
            }
        },
        toSignUp(loginForm) {
            this.toSignupLogin(loginForm)
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            //   this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style scoped>
.userRole {
  /* background-color: red; */
  margin-bottom: 30px;
}
.login-card-wrapper {
  /* height: 600px; */
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.content-wrapper {
  height: 100%;
  width: 100%;
  margin: auto;
}
/* Login inputs */
.loginInputs {
  height: 95%;
  width: 100%;
  position: relative;
}
.loginInputs p {
  width: 80%;
}
.textFields {
  width: 100%;
}

span {
  cursor: pointer;
  font-weight: bold;
  color: white;
}
.header {
  text-align: center;
}
.logoBg {
  width: 100%;
  border-radius: 14px 2px 0 0;
  background: linear-gradient(300deg, #52fe99, #04d68a);
}
.whiteCross {
  width: 100px;
  margin: 20px auto 10px auto;
}
.whiteCross img {
  width: 100%;
}
a {
  color: white;
  text-decoration: none;
  transition: all 0.5s ease;
}
a:hover {
  letter-spacing: 1px;
}

.login-card-wrapper {
  width: 100%;
}

.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media (max-width: 599px) {
  .login-card-wrapper {
    width: 90%;
    /* height: 650px; */
  }
}
@media (min-width: 599px) and (max-width: 960px) {
  .login-card-wrapper {
    width: 50%;
    min-width: 350px;
    /* height: 625px; */
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .login-card-wrapper {
    width: 40%;
    min-width: 350px;
    /* height: 625px; */
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .login-card-wrapper {
    width: 30%;
    min-width: 350px;
    /* height: 650px; */
  }
}
@media (min-width: 1904px) {
  .login-card-wrapper {
    width: 20%;
    min-width: 350px;
    /* height: 800px; */
  }
}
</style>
